import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import NRConfirmationModal from '../../NRConfirmationModal/NRConfirmationModal';
import useNRMutation from '../../../graphql/UseNRMutation';
import { QL_REMOVE_IDENTIFICATION } from '../../../graphql/queries/dependency';
import { CONSTANTS } from '../../../constants/constants';
import { useSnackbar } from 'notistack';
import CustomError from '../../../components/CustomError/CustomError';
import { SBOM_CONSTANTS } from '../SBOM.constants';

function NRSBOMRemoveModalContent({ component, onModalClose, onRefresh }) {
  const { enqueueSnackbar } = useSnackbar();

  const identificationsToRemove = Array.isArray(component?.identificationIds) ? component.identificationIds : [];
  const successMessage =
    component?.count > 1 ? CONSTANTS.MESSAGES.COMPONENTS_REMOVED_SUCCESSFULLY : CONSTANTS.MESSAGES.COMPONENT_REMOVED_SUCCESSFULLY;
  const errorMessage = component?.count > 1 ? CONSTANTS.MESSAGES.COMPONENTS_REMOVED_ERROR : CONSTANTS.MESSAGES.COMPONENT_REMOVED_ERROR;

  const [removeDependencies] = useNRMutation(QL_REMOVE_IDENTIFICATION);

  const handleModalClose = () => {
    onModalClose();
  };

  const handleRemove = () => {
    if (identificationsToRemove.length === 0) {
      enqueueSnackbar('No components selected for removal or invalid identifiers.', { variant: 'warning' });
      onModalClose();
      return;
    }

    const args = {
      composedAssetId: component?.assetId,
      identificationIds: identificationsToRemove
    };

    removeDependencies({
      variables: { args },
      context: { version: 'v3' },
      onCompleted: data => {
        const err = data?.asset?.removeDependencies?.err;

        if (err && err.trim() !== '') {
          enqueueSnackbar(<CustomError message={errorMessage} />, { variant: 'error', autoHideDuration: null });
        } else {
          enqueueSnackbar(successMessage, { variant: 'success' });
          if (onRefresh) {
            onRefresh();
          }
        }
      },
      onError: err => {
        enqueueSnackbar(<CustomError message={errorMessage} />, {
          variant: 'error',
          autoHideDuration: null
        });
      }
    });

    onModalClose();
  };

  const modalTitle = component?.count > 1 ? `${SBOM_CONSTANTS.MODAL.REMOVE_COMPONENT}s - ${component?.count}` : SBOM_CONSTANTS.MODAL.REMOVE_COMPONENT;

  return (
    <div>
      <NRConfirmationModal
        title={<Typography variant="h3">{modalTitle}</Typography>}
        content={
          <Box display="flex" flexDirection="column" gap={3}>
            <Typography variant="body1">
              This will remove the selected component from this asset and associated findings, this cannot be undone.
            </Typography>
            <Typography variant="body1">Are you sure you want to do this?</Typography>
          </Box>
        }
        open
        cancelLabel="Cancel"
        actionLabel="Remove"
        handleClose={handleModalClose}
        handleCancel={handleModalClose}
        handleActionConfirm={handleRemove}
      />
    </div>
  );
}

export default NRSBOMRemoveModalContent;
